import { Capacitor } from '@capacitor/core';
import MenuUser from '@/components/MenuUser/index.vue';
import PromotionBanner from './PromotionBanner/index.vue';
import { configureStatusBarStyle } from '@/utils/app/configureStatusBarStyle';
import UsersService from '../../services/users.service';
import LZString from 'lz-string';

export default {
    name: 'Header',

    props: ['sections'],

    components: {
        MenuUser,
        PromotionBanner
    },

    data() {
        return {
            menuMobileVisible: false,
            sectionsOffered: [],
            isIOS: false,
            isMobile: window.innerWidth <= 991,
            isVideoBannerVissible: false,
            showVideo: false,
            youtubeVideoExplaiId: '',
            player: {},
            isIOSApp: false
        };
    },

    async mounted() {
        this.isIOS = Capacitor.getPlatform() === 'ios';
        const configHasYoutubeVideoExplainEnabled = await this.$userService.getConfig(
            {},
            'HAS_YOUTUBE_VIDEO_EXPLAIN_ENABLED'
        );
        const hasYoutubeVideoExplainEnabled = JSON.parse(
            configHasYoutubeVideoExplainEnabled.data.configuration.value
        );
        if (hasYoutubeVideoExplainEnabled) {
            const configYoutubeVideoExplain = await this.$userService.getConfig(
                {},
                'YOUTUBE_VIDEO_EXPLAIN'
            );
            this.youtubeVideoExplaiId = configYoutubeVideoExplain.data.configuration.value;

            if (Capacitor.isNativePlatform()) {
                if (Capacitor.getPlatform() === 'ios') {
                    this.isIOSApp = true;
                }
            }

            if (!this.isVideoBannerVissible && this.$store.getters.videoBannerActive !== false) {
                setTimeout(() => {
                    this.$store.dispatch('setVideoBannerActive', true);
                    if (!this.isMobile) {
                        this.isVideoBannerVissible = true;
                    }
                }, 4000);
            }

            if (window.YT && window.YT.Player) {
                this.initPlayer();
            } else {
                var tag = document.createElement('script');
                tag.src = 'https://www.youtube.com/iframe_api';
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                window.onYouTubeIframeAPIReady = this.initPlayer;

                window.onYouTubeIframeAPIReady = () => {
                    this.initPlayer();
                };
            }
        }
        this.$root.$on('hideMenuMobile', () => {
            this.menuMobileVisible = false;
        });
        this.$root.$on('showVideoAction', () => {
            this.showVideoAction();
        });
        const notifications = this.unreadNotifications();
        this.$store.dispatch('setNotificationsSectionNumber', notifications.length);

        this.sectionsOffered = [...this.sections];

        await this.changeStatusBarStyle();
        if (!this.$store.getters.hiddenTaxDownBanner) {
            if (
                this.$route.name !== 'GetTaxDown' &&
                this.$store.getters.canBeTaxDown === null &&
                this.$store.getters.hasTaxDown === null
            ) {
                const taxDownAllowRes = await UsersService.getAllowTaxDown();

                this.$store.dispatch('setCanBeTaxDown', taxDownAllowRes.data.can_be_tax_down_user);
                this.$store.dispatch(
                    'setCanBeTaxDownType',
                    taxDownAllowRes.data.can_be_tax_down_user_type
                );
                this.$store.dispatch('setHasTaxDown', taxDownAllowRes.data.is_tax_down_user);
            }
        }
        if (!this.$store.getters.hiddenCobasPlusBanner) {
            if (
                this.$route.name !== 'GetCobasPlus' &&
                this.$route.name !== 'KnowCobasPlus' &&
                this.$store.getters.canBeCobasPlus === null &&
                this.$store.getters.hasCobasPlus === null &&
                this.$store.getters.redirectToCobasPlus === null
            ) {
                const cobasPlusAllowRes = await UsersService.getAllowCobasPlus();

                this.$store.dispatch(
                    'setCanBeCobasPlus',
                    cobasPlusAllowRes.data.can_be_cobas_plus_user
                );
                this.$store.dispatch('setHasCobasPlus', cobasPlusAllowRes.data.is_cobas_plus_user);
                this.$store.dispatch(
                    'setRedirectToCobasPlus',
                    cobasPlusAllowRes.data.redirect_to_cobas_plus
                );
            }
        }
    },

    methods: {
        initPlayer() {
            const _ = this;

            // eslint-disable-next-line
            this.player = new YT.Player('video-element', {
                videoId: this.youtubeVideoExplaiId,
                height: '360',
                width: '640',
                events: {
                    onReady: _.onPlayerReady
                    // onStateChange: _.onPlayerStateChange
                }
            });
        },
        onPlayerReady() {
            this.$store.dispatch('setVideoBannerActive', true);
            if (!this.isMobile) {
                setTimeout(() => {
                    this.isVideoBannerVissible = true;
                }, 300);
            }
        },

        toggleMenuMobile() {
            this.menuMobileVisible = !this.menuMobileVisible;
        },
        unreadNotifications() {
            const raw = localStorage.getItem('PACOUS');
            let private_area;

            try {
                const decompressed = LZString.decompressFromUTF16(raw);
                if (decompressed) {
                    private_area = JSON.parse(decompressed).private_area;
                } else {
                    // Fallback al formato base64 antiguo
                    private_area = JSON.parse(
                        decodeURIComponent(escape(window.atob(raw)))
                    ).private_area;
                }
            } catch (e) {
                console.error('❌ Error al descomprimir PACOUS:', e);
                private_area = {}; // Fallback en caso de error
            }

            if (!private_area.notifications) return [];

            return private_area.notifications.filter(x => x.is_read === false) || [];
        },
        checkAdmin() {
            if (localStorage.getItem('ADMIN')) {
                return true;
            } else {
                return false;
            }
        },

        async changeStatusBarStyle() {
            if (Capacitor.isNativePlatform()) {
                if (Capacitor.getPlatform() === 'ios') {
                    configureStatusBarStyle('light');
                }
            }
        },
        showVideoAction() {
            this.showVideo = true;
            // this.player.playVideo();
            const iframe = document.getElementById('video-element');
            const player = iframe.contentWindow;
            player.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        },
        closeVideo() {
            // this.player.stopVideo();
            this.showVideo = false;
            setTimeout(() => {
                const iframe = document.getElementById('video-element');
                const player = iframe.contentWindow;
                player.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
            }, 1000);
        },
        closeVideoBanner() {
            this.isVideoBannerVissible = false;
            setTimeout(() => {
                this.$store.dispatch('setVideoBannerActive', false);
            }, 1000);
        },

        async goToTaxDown() {
            try {
                this.$store.dispatch('showLoading');
                const getTaxDownUrlRes = await UsersService.getTaxDownUrl();
                this.$store.dispatch('hideLoading');
                const taxDownUrl = getTaxDownUrlRes.data.tax_down_url;

                if (Capacitor.isNativePlatform()) {
                    let inAppBrowserOptions = 'location=no, beforeload=yes';
                    if (Capacitor.getPlatform() === 'android') {
                        inAppBrowserOptions += ',zoom=no';
                    }
                    window.cordova.InAppBrowser.open(
                        encodeURI(taxDownUrl),
                        '_blank',
                        inAppBrowserOptions
                    );
                } else {
                    const newTab = window.open(taxDownUrl, '_blank');
                    if (newTab) {
                        newTab.focus();
                    } else {
                        console.warn('El navegador bloqueó la apertura de la nueva ventana');
                    }
                }
            } catch (error) {
                console.error(error);
                this.$bvToast.toast(`${error.message}`, {
                    title: 'Error',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 10000,
                    variant: 'danger'
                });
            } finally {
                this.$store.dispatch('hideLoading');
            }
        },

        goToCobasPlus() {
            let cobasPlusUrl = this.$store.getters.redirectToCobasPlus;

            if (Capacitor.isNativePlatform()) {
                let inAppBrowserOptions = 'location=no, beforeload=yes';
                if (Capacitor.getPlatform() === 'android') {
                    inAppBrowserOptions += ',zoom=no';
                }

                this.ref = window.cordova.InAppBrowser.open(
                    encodeURI(cobasPlusUrl),
                    '_blank',
                    inAppBrowserOptions
                );
            } else {
                const newTab = window.open(cobasPlusUrl, '_blank');
                if (newTab) {
                    newTab.focus();
                } else {
                    console.warn('El navegador bloqueó la apertura de la nueva ventana');
                }
            }
        },
        closeCobaPlusBanner() {
            this.$store.dispatch('setHiddenCobasPlusBanner', true);
        },
        closeTaxdownBanner() {
            this.$store.dispatch('setHiddenTaxDownBanner', true);
        }
    },

    computed: {
        currentUser() {
            const { user } = JSON.parse(
                decodeURIComponent(escape(window.atob(localStorage.getItem('PACOUS'))))
            );
            return `${user.given_name} ${user.family_name_1}`;
        },
        environment() {
            return process.env.VUE_APP_ENV;
        },
        showTaxDownBanner() {
            return (
                !this.$store.getters.hiddenTaxDownBanner &&
                this.$store.getters.canBeTaxDown &&
                this.$store.getters.canBeTaxDownType &&
                this.$route.name !== 'GetTaxDown' &&
                this.$route.name !== 'GetCobasPlus' &&
                this.$route.name !== 'KnowCobasPlus'
            );
        },
        showCobasPlusBanner() {
            return (
                !this.$store.getters.hiddenCobasPlusBanner &&
                this.$store.getters.canBeCobasPlus &&
                this.$route.name !== 'GetCobasPlus' &&
                this.$route.name !== 'KnowCobasPlus' &&
                this.$route.name !== 'GetTaxDown'
            );
        },

        banners() {
            const list = [];

            const taxDownConfig = this.taxDownConfig;

            if (this.showTaxDownBanner && taxDownConfig) {
                list.push({
                    key: 'taxdown',
                    config: taxDownConfig,
                    onClose: this.closeTaxdownBanner
                });
            }

            if (this.showCobasPlusBanner) {
                list.push({
                    key: 'cobas',
                    config: this.cobasPlusConfig,
                    onClose: this.closeCobaPlusBanner
                });
            }

            return list;
        },

        cobasPlusConfig() {
            return {
                wrapperClass: 'can-cobas-plus',

                title: '¿CONOCES COBAS PLUS?',
                description: 'Cada gasto suma a tus ahorros.',

                images: {
                    left: true,
                    right: true
                },

                secondaryLink: {
                    type: 'internal',
                    to: '/know-cobas-plus',
                    text: 'Saber más',
                    icon: 'far fa-plus-circle ml-2'
                }
            };
        },

        taxDownConfig() {
            const type = this.$store.getters.canBeTaxDownType;
            if (!type) return null;

            let title = '';
            let description = '';
            let extra = '';
            let cta = {};
            switch (type) {
                case 'FULL':
                    title = 'TAXDOWN FULL.';
                    description =
                        'Podrás hacer la declaración de la renta y otros trámites de forma gratuita con el plan TaxDown FULL.';
                    extra = '*Hasta agotar límite de licencias contratadas';
                    cta = {
                        type: 'internal',
                        to: '/get-tax-down',
                        text: 'EMPEZAR'
                    };
                    break;
                case 'PRO':
                    title = 'TAXDOWN PRO.';
                    description =
                        'Podrás hacer la declaración de la renta y otros trámites de forma gratuita con el plan TaxDown PRO.';
                    extra = '*Hasta agotar límite de licencias contratadas.';
                    cta = {
                        type: 'internal',
                        to: '/get-tax-down',
                        text: 'EMPEZAR'
                    };
                    break;
                case '25':
                default:
                    title = 'HAZ TU DECLARACION DE LA RENTA CON TAXDOWN*.';
                    description = 'Obtén un 25% de descuento por ser inversor de Cobas AM.';
                    cta = {
                        type: 'method',
                        method: this.goToTaxDown,
                        text: 'EMPEZAR'
                    };
                    break;
            }

            return {
                wrapperClass: 'can-taxdown',

                title: title,

                description: description,

                extraText: extra,

                cta: cta,

                secondaryLink: {
                    type: 'external',
                    href: 'https://taxdown.es/precios',
                    text: 'Saber más',
                    icon: 'far fa-question-circle ml-2'
                }
            };
        }
    }
};
